/* eslint-disable */

if (!customElements.get('pro-form')) {
  class ProForm extends HTMLElement {
    constructor() {
      super();
      this.options = this.querySelectorAll('.js-pro-option');
      this.input = this.querySelector('.js-pro-form-input');
      this.sellingPlanInput = this.querySelector('.js-pro-form-selling-plan-input');

      this.addListeners();
    }

    addListeners() {
      if (this.options) {
        this.options.forEach(option => {
          option.addEventListener('click', this.handleOptionClick.bind(this));
        });
      }
    }

    handleOptionClick(e) {
      const label = e.target;
      const parentContainer = label.closest('[data-checked]');

      parentContainer.dataset.checked = label.dataset.name;
      this.input.value = label.dataset.id;
      this.sellingPlanInput.value = label.dataset.sellingPlanId;
    }
    
  }

  customElements.define('pro-form', ProForm);
}